import {
  AnimationClip,
  AnimationMixer,
  Camera,
  Object3D,
  VideoTexture,
} from "three";
import { StateCreator } from "zustand";
import { GLTF } from "three-stdlib";
import { MutableRefObject } from "react";
// let saveLastTotalLoaded = 0

export const createAssetSlice: StateCreator<
  AssetSlice,
  [["zustand/subscribeWithSelector", never]],
  []
> = (set, get) => ({
  assets: new Map(),
  addAsset: (asset, key: string) => {
    set({ assets: get().assets.set(key, asset) });
  },
  getAsset: (key: string) => get().assets.get(key),
  useAssetProgress: () => {},
});

export type Asset = GltfAsset | AudioAsset | VideoAsset | Camera | Object3D;

export interface AssetSlice {
  assets: Map<
    string,
    | GltfAsset
    | AudioAsset
    | VideoAsset
    | Camera
    | Object3D
    | MutableRefObject<null>
  >;
  addAsset: (
    asset:
      | GltfAsset
      | AudioAsset
      | VideoAsset
      | Camera
      | Object3D
      | MutableRefObject<null>,
    key: string
  ) => void;
}

export type GltfAsset = {
  gltf: GLTF;
  animation: { clips: AnimationClip[]; mixer: AnimationMixer };
};
export type VideoAsset = {
  htmlVideoElement: HTMLVideoElement;
  videoTexture: VideoTexture;
};
export type AudioAsset = {
  play: (delay?: number) => void;
  stop: () => void;
  pause: () => void;
  fade: (from: number, to: number, duration: number) => void;
  sound: any;
};
